
import React, {useEffect, useState, useContext} from 'react';
import { useFetch } from './../../utils/hooks/useFetch'
import { List, Switch, Typography, message } from 'antd';
import { appContext } from "../../AppContext";
const {Text} = Typography

export default function ProfileEmailNofitications({
    originalLarper,
    refresh
}) {

    const [doFetch, FetchType] = useFetch();
    const [appState] = useContext(appContext);
    const [allTypes, setAllTypes] = useState([])

    useEffect(() => {
        doFetch("/api/larper/GetEmailNotificationTypes")
        .then((response) => loaded(response.isSuccess, response.result))

        function loaded(isSuccess, result) {
          if(isSuccess) {
            setAllTypes(result);
          }
        }
    },  // eslint-disable-next-line
    [])

    function setOnChangeSetting(isChecked, type) {

        const url = appState.user.isAdmin ? `/api/larper/AdminUpdateEmailNotification` : `/api/larper/UpdateEmailNotification`
        let body = {}

        if(isChecked) {
            body = {
                toRemove:false,
                larperId:originalLarper.id,
                type:{ 
                    id:type.id
                },
            }
        }
        else {
            body = {
                toRemove:true,
                larperId:originalLarper.id,
                id:originalLarper.emailNotifications?.find(_ => type.id === _.type.id)?.id
            }
        }
        
        doFetch(url, FetchType.POST, body)
            .then((response) => onLoaded(response.isSuccess))

        function onLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                return;
            } 

            message.error('Could not update notification setting');
        }
    }

    return (

        <List
        header={<div>Send email if</div>}
        bordered
        dataSource={allTypes}
        renderItem={item => (
            <List.Item>
                <Text>{item.displayName}</Text> 
                <Switch 
                    checked={originalLarper.emailNotifications?.find(_ => item.id === _.type.id)}
                    onChange={(_) => setOnChangeSetting(_, item)}
                />
            </List.Item>
        )}
        />
    )
}